

















































import { Vue, Component, Prop } from "vue-property-decorator"
import centers, { defaultCenter, Centers } from "@/data/centers"
import names from "@/data/names"
import references from "@/data/references"
import { contents, emotions } from "@/data/contents"
import { EnneagramNumbers } from "@/data/enneagramTypes"

@Component
export default class EnneaNumber extends Vue {
  @Prop(Number) protected readonly number: EnneagramNumbers | undefined
  @Prop(Array) protected readonly showNames: string[] | undefined
  @Prop(Array) protected readonly showEmotions: string[] | undefined
  @Prop(Object) protected readonly showContents: any | undefined

  // getters needed to make imported data available to template

  // noinspection JSMethodCanBeStatic
  get names() {
    return names
  }

  // noinspection JSMethodCanBeStatic
  get centers() {
    return centers
  }

  // noinspection JSMethodCanBeStatic
  get defaultCenter() {
    return defaultCenter
  }

  // noinspection JSMethodCanBeStatic
  get references() {
    return references
  }

  // noinspection JSMethodCanBeStatic
  get emotions() {
    return emotions
  }

  get visibleEmotions() {
    const visibleEmotions: { [key: string]: string } = {}
    if (this.showEmotions && this.number) {
      let ref: keyof typeof emotions // somehow TypeScript can't infer this automatically
      for (ref in emotions) {
        if (emotions.hasOwnProperty(ref)) {
          // check if visible (selected by user)
          const emotion = emotions[ref]
          if (this.showEmotions.indexOf(ref) >= 0 && emotion) {
            const text = emotion[this.number]
            if (text) {
              // check if emotion is already included
              if (visibleEmotions[text]) {
                visibleEmotions[text] += " & " + references[ref].author
              } else {
                visibleEmotions[text] = references[ref].author
              }
            }
          }
        }
      }
    }
    return visibleEmotions
  }

  // noinspection JSMethodCanBeStatic
  get contents() {
    return contents
  }

  get faIconName() {
    switch (this.centerName) {
      case "heart":
        return "heart"
      case "head":
        return "smile"
    }
    // what to use for "gut"?
    // options: tshirt, hand-rock, hand-paper, hand-holding-heart, fist-raised
    return "hand-paper"
  }

  get centerName() {
    const n = parseInt((this as any).number, 10)
    if (n >= 2) {
      if (n <= 4) {
        return "heart"
      }
      if (n <= 7) {
        return "head"
      }
    }
    return "gut"
  }
}
